// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"86805d1d","36":"f7514054","161":"5c01d527","254":"4b6db684","289":"a9ec9170","487":"f70ca08c","561":"f6b8a372","666":"1a286ad7","680":"ab86a886","708":"f660b4b1","727":"e9b3fe59","800":"b96c37a3","892":"57480b81","908":"b475cac8","973":"a030dc29"}[chunkId] + ".chunk.js";
};